import moment from 'moment'
import { IUserProps } from './User'
import { ReportData } from '@/infrastructure/network/Monitaro/schema/models'

export interface IReportProps {
  reports: ReportData[]
  totals: ReportData | null
  checkins: { count: number; user: IUserProps }[]
  appointments: { count: number; user: IUserProps }[]
  registrations: { count: number; user: IUserProps }[]
  withdrawals: { count: number; user: IUserProps }[]
  startedAt?: string | null
  endedAt?: string | null
}

export interface IReportQueryProps {
  start: string | null
  end: string | null
}

export default class ReportEntity {
  private _props: IReportProps

  constructor(props?: IReportProps | null) {
    this._props = EmptyReportPropsFactory(props)
  }

  get props(): IReportProps {
    return this._props
  }

  get clone(): IReportProps {
    return structuredClone(this._props)
  }

  get reports(): ReportData[] {
    return this._props.reports
  }

  get totals(): any {
    const staytime = this._props.totals?.staytime || 0
    return { arrival: 0, checkin: 0, appointment: 0, ...this._props.totals, staytime: this.format(staytime), unit: this.unit(staytime) }
  }

  get checkins(): { count: number; user: IUserProps }[] {
    return this._props.checkins
  }

  get appointments(): { count: number; user: IUserProps }[] {
    return this._props.appointments
  }

  get arrival(): number {
    return this._props.reports?.reduce((acc: number, data: any) => acc + (data.arrival ?? 0), 0) ?? 0
  }

  get withdrawal(): number {
    return this._props.reports?.reduce((acc: number, data: any) => acc + (data.withdrawal ?? 0), 0) ?? 0
  }

  get checkin(): number {
    return this._props.reports?.reduce((acc: number, data: any) => acc + (data.checkin ?? 0), 0) ?? 0
  }

  get staytime(): any {
    const total = this._props.reports?.reduce((acc: number, data: any) => acc + Number(data.staytime ?? 0), 0) ?? 0
    const avg = total / (this._props.reports?.length || 1)
    return { value: this.format(avg), unit: this.unit(avg) }
  }

  get appointment(): number {
    return this._props.reports?.reduce((acc: number, data: any) => acc + (data.appointment ?? 0), 0) ?? 0
  }

  get term(): string {
    if (this._props.startedAt && this._props.endedAt) {
      return `${moment(this._props.startedAt).format('YYYY年M月D日') + ' ～ ' + moment(this._props.endedAt).format('YYYY年M月D日')}`
    }
    return ''
  }

  get year(): string {
    if (this._props.startedAt && this._props.endedAt) {
      return `${moment(this._props.startedAt).format('YYYY年M月') + ' ～ ' + moment(this._props.endedAt).format('YYYY年M月')}`
    }
    return ''
  }

  format(value: number): number {
    if (value < 3600) {
      const minutes = Math.round(value / 60)
      return minutes
    } else {
      const hours = Math.round((value / 3600) * 100) / 100
      return hours
    }
  }

  unit(value: number): string {
    if (value < 3600) {
      return `分`
    } else {
      return `時間`
    }
  }
}

export const tabs = [
  { text: '年間推移', value: 'annual' },
  { text: '月次レポート', value: 'monthly' }
]

export const EmptyReportPropsFactory = (props?: Partial<IReportProps> | null): IReportProps => ({
  reports: [],
  totals: null,
  checkins: [],
  appointments: [],
  registrations: [],
  withdrawals: [],
  ...props
})

export const EmptyReportQueryPropsFactory = (props?: Partial<IReportQueryProps> | null): IReportQueryProps => ({
  start: null,
  end: null,
  ...props
})
